const submitFilterForm = (form) => {
  if (!form) return;
  if (form.requestSubmit) form.requestSubmit();
  else form.submit();
};

const isManualApplyFilterForm = (form) => form?.matches('[data-mobile-filter-form]');

document.addEventListener('change', (event) => {
  if (!event.target || typeof event.target.matches !== 'function') return;
  if (!event.target.matches('.gyc-filter-check input[type="checkbox"]')) return;

  const form = event.target.closest('form');
  if (isManualApplyFilterForm(form)) return;
  submitFilterForm(form);
});

document.addEventListener('change', (event) => {
  if (!event.target || typeof event.target.matches !== 'function') return;
  if (!event.target.matches('select[data-filter-select]')) return;

  const form = event.target.closest('form');
  if (isManualApplyFilterForm(form)) return;
  submitFilterForm(form);
});

document.addEventListener('change', (event) => {
  if (!event.target || typeof event.target.matches !== 'function') return;
  if (!event.target.matches('select[data-sort-select]')) return;

  const form = event.target.closest('form');
  if (form) form.submit();
});

const normalizeCustomFilterValue = (value) => String(value || '').toLowerCase().replace(/\s+/g, ' ').trim();

const setCollectionFilterUrl = ({ modelValue = '' } = {}) => {
  const url = new URL(window.location.href);
  if (modelValue) url.searchParams.set('model', modelValue);
  else url.searchParams.delete('model');
  url.searchParams.delete('page');
  window.history.replaceState({}, '', url);
};

const syncCustomFilterSelects = (selector, value) => {
  document.querySelectorAll(selector).forEach((select) => {
    const matchingOption = [...select.options].find((option) => normalizeCustomFilterValue(option.value) === value);
    select.value = matchingOption?.value || '';
  });
};

const getCustomFilterSelectValue = (selector) => {
  const select = document.querySelector(selector);
  return select?.value || '';
};

const buildModelTagFilterUrl = (select, modelHandle = '') => {
  const collectionUrl = select?.dataset.collectionUrl || window.location.pathname;
  const url = new URL(window.location.href);
  url.pathname = modelHandle ? `${collectionUrl.replace(/\/$/, '')}/${modelHandle}` : collectionUrl;
  url.searchParams.delete('model');
  url.searchParams.delete('page');
  return url;
};

const navigateToModelTagFilter = (select, modelHandle = select?.value || '') => {
  if (!select) return;
  window.location.href = buildModelTagFilterUrl(select, modelHandle).toString();
};

const applyCollectionCustomFilters = ({
  rawModelValue = getCustomFilterSelectValue('select[data-model-filter]'),
  updateUrl = false
} = {}) => {
  const modelValue = normalizeCustomFilterValue(rawModelValue);
  const cards = [...document.querySelectorAll('.gyc-filterable-card')];
  let visibleCount = 0;

  syncCustomFilterSelects('select[data-model-filter]', modelValue);

  cards.forEach((card) => {
    const models = String(card.dataset.compatibleModels || '')
      .split(',')
      .map(normalizeCustomFilterValue)
      .filter(Boolean);
    const matchesModel = !modelValue || models.includes(modelValue);
    const isVisible = matchesModel;
    card.hidden = !isVisible;
    if (isVisible) visibleCount += 1;
  });

  document.querySelectorAll('[data-custom-filter-empty], [data-model-filter-empty]').forEach((emptyState) => {
    emptyState.hidden = !modelValue || visibleCount > 0;
  });

  document.querySelectorAll('.gyc-collection-pagination').forEach((pagination) => {
    pagination.hidden = Boolean(modelValue);
  });

  if (updateUrl) setCollectionFilterUrl({ modelValue: rawModelValue });
};

const applyModelFilter = (rawValue, options = {}) => {
  applyCollectionCustomFilters({ rawModelValue: rawValue, ...options });
};

document.addEventListener('change', (event) => {
  if (!event.target || typeof event.target.matches !== 'function') return;
  if (!event.target.matches('select[data-model-filter]')) return;

  if (event.target.dataset.collectionUrl) {
    navigateToModelTagFilter(event.target);
    return;
  }

  const form = event.target.closest('form');
  if (form) {
    if (isManualApplyFilterForm(form)) return;
    submitFilterForm(form);
    return;
  }

  applyCollectionCustomFilters({
    rawModelValue: event.target.value,
    updateUrl: true
  });
});

document.addEventListener('click', (event) => {
  if (!event.target || typeof event.target.closest !== 'function') return;
  const closeButton = event.target.closest('[data-mobile-filter-close]');
  if (!closeButton) return;

  closeButton.closest('details')?.removeAttribute('open');
});

const mobileFiltersQuery = window.matchMedia('(max-width: 989px)');
let mobileFiltersScrollY = 0;

const isMobileFiltersOpen = () => Boolean(document.querySelector('.gyc-mobile-filters[open]')) && mobileFiltersQuery.matches;

const lockMobileFiltersScroll = () => {
  if (document.body.classList.contains('gyc-mobile-filters-open')) return;

  mobileFiltersScrollY = window.scrollY || document.documentElement.scrollTop || 0;
  document.body.style.top = `-${mobileFiltersScrollY}px`;
  document.body.classList.add('gyc-mobile-filters-open');
};

const unlockMobileFiltersScroll = () => {
  if (!document.body.classList.contains('gyc-mobile-filters-open')) return;

  document.body.classList.remove('gyc-mobile-filters-open');
  document.body.style.top = '';
  window.scrollTo(0, mobileFiltersScrollY);
};

const updateMobileFiltersScrollLock = () => {
  if (isMobileFiltersOpen()) lockMobileFiltersScroll();
  else unlockMobileFiltersScroll();
};

document.addEventListener('toggle', (event) => {
  const details = event.target;
  if (!details.matches?.('.gyc-mobile-filters')) return;

  if (details.open) {
    document.querySelectorAll('.gyc-mobile-filters[open]').forEach((otherDetails) => {
      if (otherDetails !== details) otherDetails.removeAttribute('open');
    });
  }

  updateMobileFiltersScrollLock();
}, true);

document.addEventListener('touchmove', (event) => {
  if (!document.body.classList.contains('gyc-mobile-filters-open')) return;
  if (event.target.closest?.('.gyc-mobile-filters__panel')) return;

  event.preventDefault();
}, { passive: false });

if (mobileFiltersQuery.addEventListener) {
  mobileFiltersQuery.addEventListener('change', updateMobileFiltersScrollLock);
} else if (mobileFiltersQuery.addListener) {
  mobileFiltersQuery.addListener(updateMobileFiltersScrollLock);
}

const initPriceRange = (root) => {
  if (root.dataset.priceRangeReady === 'true') return;

  const minRange = root.querySelector('[data-price-min-range]');
  const maxRange = root.querySelector('[data-price-max-range]');
  const priceInputs = root.nextElementSibling?.matches('.gyc-price-range')
    ? root.nextElementSibling
    : root.parentElement?.querySelector('.gyc-price-range');
  const minInput = priceInputs?.querySelector('[data-price-min-input]');
  const maxInput = priceInputs?.querySelector('[data-price-max-input]');
  if (!minRange || !maxRange || !minInput || !maxInput) return;

  root.dataset.priceRangeReady = 'true';

  const maxCap = Number(root.dataset.rangeMax || maxRange.max || 0) || 0;
  const form = root.closest('form');
  let submitTimer = null;

  const submitPriceFilter = (delay = 120) => {
    if (!form) return;
    if (isManualApplyFilterForm(form)) return;
    if (submitTimer) window.clearTimeout(submitTimer);
    submitTimer = window.setTimeout(() => {
      submitFilterForm(form);
    }, delay);
  };

  const clamp = () => {
    let minVal = Number(minRange.value || 0);
    let maxVal = Number(maxRange.value || maxCap);

    if (minVal > maxVal) {
      if (document.activeElement === minRange) {
        maxVal = minVal;
        maxRange.value = String(maxVal);
      } else {
        minVal = maxVal;
        minRange.value = String(minVal);
      }
    }

    minInput.value = String(minVal);
    maxInput.value = String(maxVal);
  };

  const syncFromInputs = () => {
    const minVal = Math.max(0, Math.min(Number(minInput.value || 0), maxCap));
    const maxVal = Math.max(0, Math.min(Number(maxInput.value || maxCap), maxCap));
    minRange.value = String(minVal);
    maxRange.value = String(maxVal);
    clamp();
  };

  minRange.addEventListener('input', () => {
    clamp();
    submitPriceFilter(420);
  });
  maxRange.addEventListener('input', () => {
    clamp();
    submitPriceFilter(420);
  });
  minRange.addEventListener('change', submitPriceFilter);
  maxRange.addEventListener('change', submitPriceFilter);
  minInput.addEventListener('input', () => {
    syncFromInputs();
    submitPriceFilter(520);
  });
  maxInput.addEventListener('input', () => {
    syncFromInputs();
    submitPriceFilter(520);
  });
  minInput.addEventListener('change', submitPriceFilter);
  maxInput.addEventListener('change', submitPriceFilter);

  clamp();
};

const initDiscoveryControls = () => {
  document.querySelectorAll('[data-price-range]').forEach((root) => {
    initPriceRange(root);
  });

  const params = new URLSearchParams(window.location.search);
  const modelFilterValue = params.get('model') || '';
  if (modelFilterValue) {
    const modelFilterSelect = document.querySelector('select[data-model-filter][data-collection-url]');
    if (modelFilterSelect) {
      const matchingOption = [...modelFilterSelect.options].find((option) => {
        return normalizeCustomFilterValue(option.textContent) === normalizeCustomFilterValue(modelFilterValue)
          || normalizeCustomFilterValue(option.value).replace(/-/g, ' ') === normalizeCustomFilterValue(modelFilterValue);
      });

      if (matchingOption?.value) {
        navigateToModelTagFilter(modelFilterSelect, matchingOption.value);
        return;
      }
    }

    applyCollectionCustomFilters({
      rawModelValue: modelFilterValue
    });
  }
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initDiscoveryControls);
} else {
  initDiscoveryControls();
}
